<template>
  <div class="life-page">
    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">合作账号查询</h2>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openEditor()">新增账号</el-button>
      </div>
      <div class="life-filter">
        <el-select v-model="filters.env" placeholder="环境" clearable style="width: 120px">
          <el-option label="测试" value="TEST" />
          <el-option label="生产" value="PROD" />
        </el-select>
        <el-input v-model="filters.appId" placeholder="AppId" clearable style="width: 180px" @keyup.enter.native="search" />
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
    </section>

    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">合作账号</h2>
      </div>
      <el-table v-loading="loading" :data="rows" border>
        <el-table-column label="环境" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.env === 'PROD' ? 'danger' : 'info'" size="small">
              {{ scope.row.env === 'PROD' ? '生产' : '测试' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="appId" label="AppId" min-width="140" />
        <el-table-column prop="baseUrl" label="基址 URL" min-width="200" show-overflow-tooltip />
        <el-table-column label="启用" width="70" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.enabled === 'Y' ? 'success' : 'info'" size="small">
              {{ scope.row.enabled === 'Y' ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="加密 PII" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.encryptPii === 'Y' ? 'success' : 'info'" size="small">
              {{ scope.row.encryptPii === 'Y' ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" width="170" />
        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="openEditor(scope.row)">编辑</el-button>
            <el-button type="text" icon="el-icon-delete" style="color: #f56c6c" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="life-pagination" :current-page.sync="page.current" :page-size="page.size"
        :page-sizes="[10, 20, 50]" :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="changeSize" @current-change="load" />
    </section>

    <el-dialog :title="form.accountId ? '编辑合作账号' : '新增合作账号'" :visible.sync="editorVisible" width="560px" @closed="onDialogClosed">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="环境" prop="env">
          <el-radio-group v-model="form.env">
            <el-radio label="TEST">测试</el-radio>
            <el-radio label="PROD">生产</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="AppId" prop="appId">
          <el-input v-model="form.appId" maxlength="64" />
        </el-form-item>
        <el-form-item :label="form.accountId ? 'Secret' : 'Secret'" prop="secretRef">
          <el-input v-model="form.secretRef" type="password" show-password maxlength="128"
            :placeholder="form.accountId ? '留空则不修改' : '请输入 Secret'" />
        </el-form-item>
        <el-form-item label="基址 URL">
          <el-input v-model="form.baseUrl" maxlength="255" placeholder="https://..." />
        </el-form-item>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="启用">
              <el-radio-group v-model="form.enabled">
                <el-radio label="Y">是</el-radio>
                <el-radio label="N">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="加密 PII">
              <el-radio-group v-model="form.encryptPii">
                <el-radio label="Y">是</el-radio>
                <el-radio label="N">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="256" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editorVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listAccounts, saveAccount, updateAccount, deleteAccount } from '@/api/life/homeServiceApi'

function emptyForm() {
  return {
    accountId: '', env: 'TEST', appId: '', secretRef: '',
    baseUrl: '', enabled: 'N', encryptPii: 'N', remark: ''
  }
}

export default {
  name: 'HomeServiceAccountList',
  data() {
    return {
      loading: false, saving: false, editorVisible: false,
      rows: [],
      filters: { env: '', appId: '' },
      page: { current: 1, size: 10, total: 0 },
      form: emptyForm(),
      rules: {
        env: [{ required: true, message: '请选择环境', trigger: 'change' }],
        appId: [{ required: true, message: '请输入 AppId', trigger: 'blur' }]
      }
    }
  },
  created() { this.load() },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await listAccounts({ ...this.filters, page: this.page.current, row: this.page.size })
        this.rows = res.data || []
        this.page.total = Number(res.total || 0)
      } catch (error) {
        this.$message.error(error.message || '加载合作账号列表失败')
      } finally { this.loading = false }
    },
    search() { this.page.current = 1; this.load() },
    reset() { this.filters = { env: '', appId: '' }; this.search() },
    changeSize(size) { this.page.size = size; this.load() },
    openEditor(row) {
      if (row) {
        this.form = { ...row, secretRef: '' }
      } else {
        this.form = emptyForm()
      }
      this.editorVisible = true
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    onDialogClosed() {
      this.$refs.formRef && this.$refs.formRef.resetFields()
      this.form = emptyForm()
    },
    submit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        if (!this.form.accountId && !this.form.secretRef) {
          this.$message.warning('新增账号时 Secret 不能为空')
          return
        }
        this.saving = true
        try {
          const payload = { ...this.form }
          if (this.form.accountId && !payload.secretRef) {
            delete payload.secretRef
          }
          if (this.form.accountId) {
            await updateAccount(payload)
          } else {
            await saveAccount(payload)
          }
          this.$message.success('合作账号已保存')
          this.editorVisible = false
          this.load()
        } catch (error) {
          this.$message.error(error.message || '保存失败')
        } finally { this.saving = false }
      })
    },
    handleDelete(row) {
      this.$confirm(`确认删除账号「${row.appId}」？`, '提示', { type: 'warning' }).then(async () => {
        try {
          await deleteAccount({ accountId: row.accountId })
          this.$message.success('已删除')
          if (this.rows.length === 1 && this.page.current > 1) this.page.current--
          this.load()
        } catch (error) {
          this.$message.error(error.message || '删除失败')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/views/lifeService/life.scss';
</style>
